import { ref } from 'vue'
import { defineStore } from 'pinia'
import { getMsgList, codeGrpDtlList } from '@/api/common'

export const useCodeStore = defineStore(
  'code',
  () => {
    const apiCodeList = ref(null)
    const codeDtlList = ref(null)

    function getCodeMsg(code) {
      return apiCodeList.value[code]
    }

    function getCodeNm(grp,val){
      if(codeDtlList.value){
       return codeDtlList.value.find(item => item.cd_gr === grp && item.cd_id === val)
      }else{
        return ''
      }
    }

    async function getApiCodeList() {
      apiCodeList.value = null
      try {
        const result = await getMsgList()
        apiCodeList.value = Object.fromEntries(result.rtn.map(code => {
          return [code.cd_id, code.cd_val]
        }))
      } catch (err) {
        console.error(err)
      }
    }

    async function getCodeDtlList() {
      codeDtlList.value = null
      try {
        const result = await codeGrpDtlList()
        codeDtlList.value = result.rtn.map((code) => {
          if (code.cd_id == 'YN001') {
            code.cd_id = 'N'
          } else if (code.cd_id == 'YN002') {
            code.cd_id = 'Y'
          }
          return code
        })
      } catch (err) {
        console.error(err)
      }
    }

    async function initAllCodeList() {
      try {
        await Promise.allSettled([getApiCodeList(), getCodeDtlList()])
      } catch (err) {
        throw new Error(err)
      }
    }

    return { apiCodeList, codeDtlList, getCodeMsg, getCodeDtlList, initAllCodeList ,getCodeNm}
  },
  {
    persist: true,
  },
)